/*
 * @Author: liyxt
 * @Date: 2020-05-06 14:00:41
 * @LastEditors: liyxt
 * @LastEditTime: 2020-05-28 15:37:35
 * @Description: file content
 */
import React, { Component } from 'react';
import OriginTree from 'bee-tree';
import classNames from 'classnames';
import hotkeys from './hotkeys';

require('bee-tree/build/Tree.css');
require('./index.less');

const TreeNode = OriginTree.TreeNode;

@hotkeys(true)
class Tree extends Component {
	render() {
		let { openIcon, closeIcon, className, debounceDuration = 10, ...others } = this.props;
		return <OriginTree
			openIcon={
				typeof openIcon === "function" ? (
					openIcon()
				) : (
					<i
						className="icon iconfont icon-shu_zk tree-swich"
					/>
				)
			}
			closeIcon={
				typeof closeIcon === "function" ? (
					closeIcon()
				) : (
					<i
						className="icon iconfont icon-shushouqi tree-swich"
					/>
				)
			}
			debounceDuration={debounceDuration}
			{...others}
			className={classNames('nc-tree', className)}
		/>;
	}
}
Tree.TreeNode = TreeNode;
export default Tree;
